import { Color, DefaultValue, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S12};
  padding: ${Spacing.S16};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  ${getShadow('elevatedStrong')};
`

export const FullWidthDivider = styled.div`
  margin: 0 -${Spacing.S16};
`
